import router from '../../../router'
import _ from 'lodash'
export default {
  data () {
    return {
      currentPage: 0,
      pageType: 'templates',
      prevPage: 0,
      nextPage: 1,
      allPageIdMap: {},
      totalPages: 1
    }
  },
  computed: {
    canGoToPrev () {
      return this.prevPage < 0
    },
    getCurrentPage () {
      return this.currentPage + 1
    },
    canGoToNext () {
      if (this.allPageIdMap) {
        return this.nextPage >= _.size(this.allPageIdMap)
      }
    }
  },
  methods: {
    setPagination (pageType) {
      this.pageType = pageType
      this.currentPage = this.getPageNo(this.id)
      this.prevPage = this.currentPage - 1
      this.nextPage = this.currentPage + 1
      this.totalPages = _.size(this.allPageIdMap)
    },
    goToPage (id, saveData = true) {
      if (id != null) {
        if (this.currentIndex && this.currentIndex > 0 && saveData) { this.saveData() }
        if (this.pageType !== 'process/forms') {
          router.push({path: `/${this.pageType}/${this.getcurrentDocId(id)}`})
        } else {
          if (this.checkIdRelatedFormDoc()) {
            router.push({path: `/${this.pageType}/${this.getcurrentDocId(id)}`})
          }
        }
      }
    },
    checkIdRelatedFormDoc () {
      if (this.id in (this.allPageIdMap)) {
        return false
      }
      return true
    },
    getPageNo (currentDocId) {
      return this.allPageIdMap[currentDocId]
    },
    getcurrentDocId (pageNo) {
      return (_.invert(this.allPageIdMap))[pageNo]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/pagination.js